import { useState, useEffect } from 'react';
import { portalApi } from '../../api';

function money(n: number) {
  return '¥' + Number(n || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function PortalStatements() {
  const [data, setData] = useState<any>({ monthly: [], summary: { total_orders: 0, total_amount: 0 }, last: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    portalApi('/statements').then(setData).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-bold text-emerald-800">🧾 对账中心</h2>
      {loading && <div className="text-slate-400 text-sm">加载中…</div>}
      {!loading && (
        <>
          <div className="bg-gradient-to-br from-emerald-600 to-emerald-800 text-white rounded-xl shadow p-4">
            <div className="text-sm opacity-80">累计报货</div>
            <div className="flex justify-around mt-2 text-center">
              <div><div className="text-2xl font-bold">{data.summary.total_orders}</div><div className="text-xs opacity-80">笔</div></div>
              <div><div className="text-2xl font-bold">{money(data.summary.total_amount)}</div><div className="text-xs opacity-80">金额合计</div></div>
            </div>
          </div>

          {data.last && (
            <div className="bg-white rounded-xl shadow-sm p-3 border border-slate-100">
              <div className="flex justify-between">
                <span className="font-mono text-sm">{data.last.order_no}</span>
                <span className="text-emerald-600 font-bold">{money(data.last.total_amount)}</span>
              </div>
              <div className="text-xs text-slate-400 mt-1">
                {(data.last.created_at || '').slice(0, 19).replace('T', ' ')} · 状态：{data.last.status}
              </div>
            </div>
          )}

          <div className="text-sm font-bold text-slate-600 mt-2">月度报货对账</div>
          {data.monthly.length === 0 && <div className="text-slate-400 text-sm">暂无报货记录</div>}
          {data.monthly.map((m: any) => (
            <div key={m.month} className="bg-white rounded-xl shadow-sm p-3 border border-slate-100">
              <div className="flex justify-between">
                <span className="font-medium">{m.month} 月</span>
                <span className="text-emerald-600 font-bold">{money(m.total_amount)}</span>
              </div>
              <div className="text-xs text-slate-400 mt-1">
                {m.order_count} 笔 · 待接 {m.pending || 0} · 已确认 {m.confirmed || 0} · 完成 {m.done || 0}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
